import { render } from "./TemperatureVersusCurrentReport.vue?vue&type=template&id=cd4ab348"
import script from "./TemperatureVersusCurrentReport.vue?vue&type=script&lang=js"
export * from "./TemperatureVersusCurrentReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__